import { render, staticRenderFns } from "./SeminarAdd.vue?vue&type=template&id=2436ff87&scoped=true&"
import script from "./SeminarAdd.vue?vue&type=script&lang=js&"
export * from "./SeminarAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2436ff87",
  null
  
)

export default component.exports